import states from 'app/shared/utils/states.json';

type StateEntry = {
  id: number;
  name: string;
  abbreviation: string;
  resourceId: string;
  topCities: Array<string>;
};

export const STATE_CANONICAL_ORIGIN = 'https://hotpads.com';

// Both helpers expect the URL slug (e.g. 'california'), not the API's
// `area.resourceId` (which is the two-letter abbreviation, e.g. 'ca').
// Derive the slug from the route pathname at the call site.

export function buildStateCanonicalHref(urlSlug: string | null | undefined): string | null {
  if (!urlSlug) {
    return null;
  }
  return `${STATE_CANONICAL_ORIGIN}/${urlSlug.toLowerCase()}`;
}

export function getOtherStates(currentUrlSlug: string | null | undefined): Array<StateEntry> {
  const normalized = (currentUrlSlug || '').toLowerCase();
  return (states as Array<StateEntry>).filter((s) => s.resourceId !== normalized);
}
